// import { useState } from "react";
// import images from "../../assets/images/Constant";
// import homeData from "../../data/home.json";

// export default function EasySteps({ showSlider = true }) {

//   const [index, setIndex] = useState(0);

//   const steps = homeData?.steps || {};
//   const items = steps?.items || [];
//   const sliderImages = steps?.sliderImages || [];

//   return (
//     <section className="bg-white py-16 md:py-24">

//       <div className="max-w-[1200px] mx-auto px-6 text-center">

//         {/* SMALL TITLE */}
//         <div className="flex gap-2 justify-center items-center py-5">
//   <img src={images[steps.icon1]} alt="" />

//         <p className="text-primary text-base md:text-[22px] font-medium tracking-wider ">
//           {steps.subtitle}
//         </p>
// </div>
//         {/* HEADING */}
//         <h2 className="text-3xl md:text-heading font-semibold text-dark leading-tight">
//           {steps.title}
//           <span className="block ">
//               {steps.highlight}
//             </span>
//         </h2>

//         {/* PROCESS SECTION */}
//         <div className="relative mt-12 md:mt-16">

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-6 relative">

//             {items.map((step, i) => (

//               <div key={i} className="">

//                 <div className="w-20 h-20 md:w-[100px] md:h-[100px] mx-auto mt-6 flex items-center justify-center">
//                   <img
//                     src={images[step.icon]}
//                     alt={step.title}
//                     className="w-12 md:w-auto"
//                   />
//                 </div>

//                 <h3 className="pt-5 font-semibold text-lg md:text-subheading text-dark">
//                   {step.title}
//                 </h3>

//                 <p className="text-light leading-normal text-sm md:text-description mt-2 ">
//                   {step.description}
//                 </p>

//               </div>

//             ))}

//           </div>

//         </div>

//       </div>

//       {/* IMAGE SLIDER */}
//       {showSlider && (
//   <div className="mt-16 md:mt-24 px-4">

//     <div className="relative overflow-hidden">

//       <div
//         className="flex transition-transform duration-500"
//         style={{ transform: `translateX(-${index * 100}%)` }}
//       >

//         {/* GROUP 1 */}
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 min-w-full">
//           {sliderImages.slice(0,4).map((img, i) => (
//             <img
//               key={i}
//               src={images[img]}
//               alt=""
//               className="w-full h-[200px] md:h-[350px] lg:h-[579px] object-cover"
//             />
//           ))}
//         </div>

//         {/* GROUP 2 */}
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 min-w-full">
//           {sliderImages.slice(4,8).map((img, i) => (
//             <img
//               key={i}
//               src={images[img]}
//               alt=""
//               className="w-full h-[200px] md:h-[350px] lg:h-[579px] object-cover"
//             />
//           ))}
//         </div>

//       </div>

//     </div>

//     {/* DOTS */}
//     <div className="flex justify-center gap-3 mt-6">
//       {[0,1].map((dot) => (
//         <span
//           key={dot}
//           onMouseEnter={() => setIndex(dot)}
//           className={`w-3 h-3 md:w-4 md:h-4 rounded-full cursor-pointer transition 
//           ${index === dot ? "bg-primary" : "bg-secondary"}`}
//         ></span>
//       ))}
//     </div>

//   </div>
// )}
//     </section>
//   );
// }





import { useEffect, useState, useRef, useCallback } from "react";
import images from "../../assets/images/Constant";
import homeData from "../../data/home.json";

export default function EasySteps({ showSlider = true }) {

  const [index, setIndex] = useState(0);
  const viewportRef = useRef(null);
  const [viewportWidth, setViewportWidth] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(2);

  const updateSlidesPerView = useCallback(() => {
    const w = window.innerWidth;
    if (w >= 1024) setSlidesPerView(4);
    else if (w >= 768) setSlidesPerView(3);
    else setSlidesPerView(2);
  }, []);

  useEffect(() => {
    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
    return () => window.removeEventListener("resize", updateSlidesPerView);
  }, [updateSlidesPerView]);

  useEffect(() => {
    if (!showSlider) return;
    const el = viewportRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => setViewportWidth(el.clientWidth));
    ro.observe(el);
    setViewportWidth(el.clientWidth);
    return () => ro.disconnect();
  }, [showSlider]);

  const slideWidth =
    viewportWidth > 0 && slidesPerView > 0
      ? viewportWidth / slidesPerView
      : 0;

  const steps = homeData?.steps || {};
  const items = steps?.items || [];
  const sliderImages = steps?.sliderImages || [];
const loopImages = [...sliderImages, ...sliderImages];
  useEffect(() => {
  const interval = setInterval(() => {
    setIndex((prev) => prev + 1);
  }, 3000);

  return () => clearInterval(interval);
}, []);

 useEffect(() => {
  if (index >= sliderImages.length) {
    setTimeout(() => {
      setIndex(0);
    }, 500); // transition ke baad reset
  }
}, [index, sliderImages.length]);

  return (
    <section className="bg-white py-16 md:py-24">

      <div className="max-w-[1200px] mx-auto px-6 text-center">

        {/* SMALL TITLE */}
        <div className="flex gap-2 justify-center items-center py-5">
  <img src={images[steps.icon1]} alt="" />

        <p className="text-primary text-base md:text-[22px] font-medium tracking-wider ">
          {steps.subtitle}
        </p>
</div>
        {/* HEADING */}
        <h2 className="text-3xl md:text-heading font-semibold text-dark leading-tight">
          {steps.title}
          <span className="block ">
              {steps.highlight}
            </span>
        </h2>

        {/* PROCESS SECTION */}
        <div className="relative mt-12 md:mt-16">

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-6 relative">

            {items.map((step, i) => (

              <div key={i} className="">

                <div className="w-20 h-20 md:w-[100px] md:h-[100px] mx-auto mt-6 flex items-center justify-center">
                  <img
                    src={images[step.icon]}
                    alt={step.title}
                    className="w-12 md:w-auto"
                  />
                </div>

                <h3 className="pt-5 font-semibold text-lg md:text-subheading text-dark">
                  {step.title}
                </h3>

                <p className="text-light leading-normal text-sm md:text-description mt-2 ">
                  {step.description}
                </p>

              </div>

            ))}

          </div>

        </div>

      </div>

      {/* IMAGE SLIDER */}
      {showSlider && (
  <div className="mt-16 md:mt-24 px-2 sm:px-4 max-w-full overflow-hidden">
  <div className="overflow-hidden" ref={viewportRef}>

    <div
      className="flex transition-transform duration-500 ease-out"
      style={{
        transform:
          slideWidth > 0
            ? `translateX(-${index * slideWidth}px)`
            : "translateX(0)",
      }}
    >

      {loopImages.map((img, i) => (
        <div
          key={`${img}-${i}`}
          className="flex-shrink-0 box-border px-1.5 sm:px-2"
          style={{
            width:
              slideWidth > 0
                ? `${slideWidth}px`
                : `${100 / Math.max(slidesPerView, 1)}%`,
          }}
        >
          <img
            src={images[img]}
            alt=""
            className="w-full h-[180px] sm:h-[220px] md:h-[350px] lg:h-[579px] object-cover"
          />
        </div>
      ))}

    </div>

  </div>


    {/* DOTS */}
    {/* <div className="flex justify-center gap-3 mt-6">
  {sliderImages.map((_1, dot) => (
    <span
      key={dot}
      onMouseEnter={() => setIndex(dot)}
      className={`w-3 h-3 md:w-4 md:h-4 rounded-full cursor-pointer 
      ${index === dot ? "bg-primary" : "bg-secondary"}`}
    ></span>
  ))}
</div> */}

  </div>
)}
    </section>
  );
}